import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
//#endregion
//#region services
import { useCurrencyService } from "serviceHooks";
//#endregion
import {
  HighReceiptAmountThresholdSEK,
  ReceiptCategoryTypesRequiringVATWarning,
} from "utils/constants/receiptConstants";

function useHighReceiptAmountWarning(
  amount: number | undefined,
  currency: string | undefined,
  categoryType: number | undefined,
  hasCategory: boolean,
  date?: Date
) {
  const currencyService = useCurrencyService();
  const [shouldShow, setShouldShow] = React.useState(false);

  const categoryEligible =
    hasCategory &&
    (categoryType === undefined || ReceiptCategoryTypesRequiringVATWarning.includes(categoryType));

  React.useEffect(() => {
    let cancelled = false;

    const evaluate = async () => {
      if (!amount || amount <= 0 || !currency || !categoryEligible) {
        if (!cancelled) setShouldShow(false);
        return;
      }

      const currencyUpper = currency.toUpperCase();

      if (currencyUpper === CurrencyEnums.CurrencyCode.SEK) {
        if (!cancelled) setShouldShow(amount > HighReceiptAmountThresholdSEK);
        return;
      }

      try {
        const exchangeRate = await currencyService.getExchangeRate(currency, date ?? new Date());
        if (!cancelled) setShouldShow(amount * exchangeRate > HighReceiptAmountThresholdSEK);
      } catch (error) {
        console.error("Failed to get exchange rate for receipt amount warning:", error);
        if (!cancelled) setShouldShow(false);
      }
    };

    evaluate();

    return () => {
      cancelled = true;
    };
  }, [amount, currency, categoryEligible, date?.toString()]);

  return shouldShow;
}

export default useHighReceiptAmountWarning;
